import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {Icon, Button, Menu, Dropdown, message, Popconfirm, Select, Input} from 'antd';

const {Option, OptGroup} = Select;
import {DmsTab, TableView, FilterBox} from 'Components';
import {fetchList2, Update2, getCusName, getItem, add} from '../../service/billingCtrl';
import {objectSerial, config, openNotice} from 'Utils';
import {addLink} from "../../service/customOrder";
import querystring from 'querystring';

let timeout;
let currentValue;

class CustItemList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['客户专属物料'],
            key: 0,
            rows: [],
            total: 0,
            selectedKeys: [],
            data: [],
            itemNum: [],
            itemDesc: [],
            value: '',
            visible: false,
            fetching: false,
            cusName: [],
            filterBoxVisible: false,
            orderNumber: '',
            searchObj: {
                thirdId: '',
                p: 1,
                s: 10
            },
        };

        this.pageChange = this.pageChange.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.goView = this.goView.bind(this);
        this.getData = this.getData.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.dropdownClick = this.dropdownClick.bind(this);
        this.cusChange = this.cusChange.bind(this);
    }


    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }


    componentDidMount() {
        this.getData();
        getCusName().then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    cusName: result.data
                })
            } else {
                message.error(result.message);
            }
        })
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    fetch(value, callback) {

        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }

        function fake() {
            currentValue = value;
            const param = {
                itemNum: value
            }
            getItem(param).then(result => {
                if (result.status && result.code == 200) {
                    const data = [];
                    if (currentValue === value) {
                        result.data.forEach(r => {
                            data.push({
                                value: r.id,
                                text: r.itemNum,
                                text2: r.itemDesc
                            });
                        });
                        callback(data);
                    }
                }
            })
        }

        timeout = setTimeout(fake.bind(this), 1000);
    }


    //请求数据
    getData() {
        fetchList2(this.state.searchObj).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    rows: result.data,
                    total: result.total
                })
            } else {
                message.error(result.message);
            }
        })
    }

    goView(url) {
        hashHistory.push(url);
    }

    save(value, key, index) {
        if (key.itemNum == '' || key.itemNum == null) {
            openNotice('error', '请填写物料编码');
            return;
        }

        var obj = {
            "custId": key.custId,
            "itemNum": key.itemNum,
            "orderNumber": key.orderNumber
        }

        add(obj).then(result => {
            if (result.status && result.code == 200) {
                openNotice('success', '保存成功')
                this.getData();
            } else {
                openNotice('error', result.message)
            }
        })
    }

    /*新增行*/
    saveRows = (record, text) => {
        const self = this;
        var Rows = [...this.state.rows];
        var addSave = [{...record}];
        addSave.customerName = '';
        addSave.itemNum = '';
        addSave.itemDesc = '';
        addSave.orderNumber = '';
        addSave.custId = '';
        Rows.push(addSave);
        self.setState({
            rows: Rows,
        });
    }


    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceSubmit = (form) => {
        this.setState({
            filterBoxVisible: !this.state.filterBoxVisible,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            this.getData();
        });

    };

    advanceReset = () => {
        this.setState({
            filterBoxVisible: !this.state.filterBoxVisible,
            searchObj: {
                customerNmae: null,
                itemNum: null,
                p: 1
            }
        }, () => {
            this.getData();
        });
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}});
    };

    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            this.getData();
        });
    }

    exportChange() {
        let url = `${config.server}/api/v1/dmsOrderManage/exportExcel2`;
        window.open(url);
    };


    //select 中的单击事件
    handleChange = (index, value) => {
        var Rows = [...this.state.rows];
        Rows[index].itemNum = value;
        this.setState({
            rows: Rows
        });
        this.fetch(value, data => this.setState({data}));
    }

    cusChange = (index, value) => {
        var Rows = [...this.state.rows];
        Rows[index].custId = value;
        this.setState({
            rows: Rows
        });
    }

    orderNumChange = (index, event) => {
        var Rows = [...this.state.rows];
        Rows[index].orderNumber = event.target.value;
        this.setState({
            rows: Rows
        });
    }


    dropdownClick({item, key, keyPath}) {
        let url = window.location.href
        const {selectedKeys} = this.state;
        selectedKeys.push(key);
        this.setState({
            selectedKeys
        });
        var arr = key.split('_');

        if (arr[0] === '1') {
            if (this.state.rows[arr[1]].status === 1) {
                Update2({id: this.state.rows[arr[1]].id, status: 0}).then(result => {
                    if (result.status) {
                        message.success(result.message);
                        this.getData();
                    } else {
                        message.error(result.message);
                    }
                })
            } else {
                //启用配置
                Update2({id: this.state.rows[arr[1]].id, status: 1}).then(result => {
                    if (result.status) {
                        message.success(result.message);
                        this.getData();
                    } else {
                        message.error(result.message);
                    }
                })
            }

        }

        if (arr[0] === '2') {
            Update2({id: this.state.rows[arr[1]].id, removeFlag: 1}).then(result => {
                if (result.status) {
                    message.success(result.message);
                    this.getData();
                } else {
                    message.error(result.message);
                }
            })
        }
    }

    menu(index) {
        return (
            <Menu style={{width: '100px', textAlign: 'center'}} onClick={this.dropdownClick}>
                <Menu.Item key={`1_${index}`}>{this.state.rows[index].status === 1 ? '禁用' : '启用'}</Menu.Item>
                <Menu.Item key={`2_${index}`}>删除</Menu.Item>
            </Menu>
        )
    }

    render() {
        const {opts, filterBoxVisible, rows, total, searchObj, channelList, cusName, visible} = this.state;

        const Option = Select.Option;
        const options = this.state.data.map(result => <Option key={result.value}
                                                              value={result.text}>{result.text} - {result.text2}</Option>);
        // 筛选弹窗
        const filterBoxProps = {
            showFlag: filterBoxVisible,
            advance: {
                fileds: [
                    {
                        name: 'customerName',
                        label: '客户名称',
                    },
                    {
                        name: 'itemNum',
                        label: '物料编码',
                    },
                ],
                handle: this.advanceSubmit,
                reset: this.advanceReset,
                fieldHandle: this.setFilterParam
            }
        };
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'key',
            pageParam: {
                total: total,
                current: this.state.searchObj.p,//当前页码
                pageSize: this.state.searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '客户名称',
                    dataIndex: 'customerName',
                    render: (text, record, index) => {
                        const cusNAME = this.state.cusName;
                        if (record.id == '' || record.id == null) {
                            return (<Select
                                showSearch
                                placeholder='请选择客户'
                                style={{width: 200}}
                                allowClear={true}
                                showArrow={true}
                                dropdownMatchSelectWidth={false}
                                dropdownStyle={{backgroundColor: '#FFFFFF', borderColor: '#2f0cff', borderSize: '2px'}}
                                onSelect={this.cusChange.bind(this, index)}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                <OptGroup>
                                    {(cusName || '').map(function (ele, index) {
                                        return <Option key={cusNAME[index].thirdId}
                                                       value={cusNAME[index].thirdId}>{cusNAME[index].name}</Option>;
                                    })}
                                </OptGroup>
                            </Select>)
                        } else {
                            return record.customerName
                        }
                    }
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    render: (text, record, index) => {
                        if (record.id == '' || record.id == null) {
                            return (<Select
                                mode="combobox"
                                showArrow={false}
                                filterOption={false}
                                placeholder='请输入物料编码'
                                dropdownMatchSelectWidth={false}
                                style={{width: '140px', borderSize: '2px'}}
                                dropdownStyle={{backgroundColor: '#FFFFFF', borderColor: '#2f0cff', borderSize: '2px'}}
                                onChange={this.handleChange.bind(this, index)}
                            >
                                {options}
                            </Select>)
                        } else {
                            return record.itemNum
                        }
                    }
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '定制订单',
                    dataIndex: 'orderNumber',
                    render: (text, record, index) => {
                        if (record.id == '' || record.id == null) {
                            return (
                                <Input type="text" placeholder="请输入定制订单编号"
                                       onChange={this.orderNumChange.bind(this, index)}/>
                            );
                        } else {
                            return record.orderNumber
                        }
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    render: (text) => {
                        if (text === 1) {
                            return '已启用'
                        } else {
                            return '已禁用'
                        }
                    }
                },
                {
                    title: '更多操作',
                    key: 'action',
                    className: 'status',
                    render: (text, record, index) => (
                        <Dropdown overlay={this.menu(index)}
                                  placement='bottomCenter'
                                  trigger={['click']}>
							<span className="ant-dropdown-link">
								<Icon type="caret-down"/>
							</span>
                        </Dropdown>
                    )
                }, {
                    title: '其他操作',
                    dataIndex: 'other',
                    render: (text, record, index) => {
                        if (record.id == '' || record.id == null) {
                            return (<Button onClick={() => this.save(text, record, index)}>保存</Button>)
                        }
                    }
                }
            ],
            rows
        };
        this.cacheData = rows.map(item => ({...item}));
        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        <Button icon="plus"
                                onClick={this.saveRows.bind(this)}>新增</Button>
                        <Button icon="filter" onClick={this.visibleChange}>筛选</Button>
                        <Button icon="export" onClick={this.exportChange}>导出</Button>
                        <FilterBox {...filterBoxProps}/>
                    </DmsTab>
                </div>

                <div className="dms-table-box">
                    <TableView {...tableViewProps} />
                </div>
            </div>

        )
    }

};

export default withRouter(CustItemList);




// WEBPACK FOOTER //
// ./src/routes/billingCtrl/list2.js